import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/90 backdrop-blur-lg shadow-lg shadow-cyan-500/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img
              src="https://static.readdy.ai/image/c4da685b094ca03001fa4ce318bf4660/f59786c2d124de0541605a3b17561e77.png"
              alt="FurukoNetwork Logo"
              className="w-12 h-12 rounded-full ring-2 ring-cyan-400/50"
            />
            <span className="text-2xl font-bold text-white">FurukoNetwork</span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-300 hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              Ana Sayfa
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-300 hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              Hakkında
            </button>
            <button
              onClick={() => scrollToSection('server-ip')}
              className="text-gray-300 hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              Sunucu IP
            </button>
            <button
              onClick={() => scrollToSection('discord')}
              className="text-gray-300 hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              Discord
            </button>
            <button
              onClick={() => scrollToSection('shop')}
              className="text-gray-300 hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              Mağaza
            </button>
          </div>

          <a
            href="https://discord.gg/FurukoNetwork"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-2.5 bg-[#5865F2] hover:bg-[#4752C4] text-white rounded-full font-semibold transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Discord'a Katıl
          </a>
        </div>
      </div>
    </nav>
  );
}
